
import { useMemo } from "react";
import Website from "./pages/Website";
import DocumentHelper from "./helpers/DocumentHelper";
import DefaultConstants from "./data/Constants";
import DefaultImages from "./data/Images";


const App = () => {
  return useMemo(() => {
    DocumentHelper.setTitle(DefaultConstants.websiteName);
    DocumentHelper.setFavIcon(DefaultImages.icon.colorful);
    
    return <Website />;
  }, []);
}

export default App;
